import { render } from "./appFooter.vue?vue&type=template&id=dc745c42"
import script from "./appFooter.vue?vue&type=script&lang=js"
export * from "./appFooter.vue?vue&type=script&lang=js"

import "./appFooter.vue?vue&type=style&index=0&id=dc745c42&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__